import React, { useState, useEffect } from "react";

function MLTFGPT1({
  label,
  value,
  onChange,
  rows = 4,
  disabled,
  auto_scale = false,
  refreshRows = false,
  transparent = true,
  className = "text-h3",
  canResize = false,
}) {
  const [dynamicRows, setDynamicRows] = useState(rows);

  useEffect(() => {
    if (auto_scale && value != null) {
      // Count the number of lines based on line breaks
      const lineCount = value.split("\n").length;
      // Set the number of rows dynamically, ensuring a minimum value
      setDynamicRows(Math.max(rows, lineCount));
    }
  }, [value, auto_scale, rows, refreshRows]);

  return (
    <div className=" w-full flex text-h3 ">
      <textarea
        value={value}
        onChange={onChange}
        disabled={disabled}
        // allow resizing vertial if canResize is true
        style={{ resize: canResize ? "vertical" : "none" }}
        rows={auto_scale ? dynamicRows : rows} // Dynamically increase rows
        placeholder={label}
        className={`  w-full border-1 ${className} ${disabled ? "bg-shadow_5 text-shadow_25" : transparent ? "bg-transparent text-black" : "bg-white text-black"} border-gray-300 rounded-lg p-2  focus:outline-none focus:ring-2 focus:ring-blue-300 focus:border-transparent resize-none`}
      />
    </div>
  );
}

export default MLTFGPT1;
